export class LocationRequest {
    public AuditID: number;
    public CustomerID: number;
    public FeatureID: number;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}